Modules.EmailSubscription.Helpers.Selectors = {
  COUPONS_ALERTS_SELECTOR: '.coupon-email-alert',
  MERCHANT_ALERTS_SELECTOR: '.merchant-email-alert'
};

module.exports = Modules.EmailSubscription.Helpers.Selectors;

